import { FC } from 'react';
import styles from './styles.module.css';
import { addDays, format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

type Props = {
  start: Date;
  count: number;
  onStartDateChange: (newDate: Date) => void;
};
const WeekControl: FC<Props> = ({ start, count, onStartDateChange }) => {
  const end = addDays(start, 6);
  const nextDate = () => onStartDateChange(addDays(start, 7));
  const backDate = () => onStartDateChange(addDays(start, -7));
  const dateLabel = `${format(start, 'M/d(E)', { locale: ja })} ~ ${format(
    end,
    'd(E)',
    { locale: ja }
  )}`;
  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={backDate}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </button>
      <div className={styles.content}>
        <div className={styles.dateLabel}>{dateLabel}</div>
        <div>
          <span className={styles.count}>{count}</span>
          <span className={styles.unit}>件</span>
        </div>
      </div>
      <button className={styles.button} onClick={nextDate}>
        <FontAwesomeIcon icon={faAngleRight} />
      </button>
    </div>
  );
};

export default WeekControl;
